/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Footer_BlurbInputs */

const en_platform_footer_blurb = /** @type {(inputs: Platform_Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The booking, plans and payments software personal trainers actually run their week on.`)
};

const pl_platform_footer_blurb = /** @type {(inputs: Platform_Footer_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje, plany i płatności, na których trenerzy personalni naprawdę prowadzą swój tydzień.`)
};

/**
* | output |
* | --- |
* | "The booking, plans and payments software personal trainers actually run their week on." |
*
* @param {Platform_Footer_BlurbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_footer_blurb = /** @type {((inputs?: Platform_Footer_BlurbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Footer_BlurbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_footer_blurb(inputs)
	return en_platform_footer_blurb(inputs)
});